var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverifyFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2a2.547 2.547 0 012.539 2.548v0c0 .51-.153 1.011-.439 1.433l-.396.585a.067.067 0 00-.012.038v.432c0 .705.5 1.312 1.191 1.449l1.094.215c.885.174 1.523.95 1.523 1.852V12h-11v-1.448c0-.902.638-1.678 1.523-1.852l1.094-.215a1.476 1.476 0 001.19-1.449v-.432a.067.067 0 00-.01-.038L5.9 5.981a2.56 2.56 0 01-.438-1.433v0A2.547 2.547 0 018 2v0z",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5h11",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/unverify_folder.18787679.svg";
export { SvgUnverifyFolder as ReactComponent };